<template>
	<div class="panel publications">
		<div class="container">
			<div v-if="currentPublications.length" class="panel_header">
				<h2>
					{{ $t('keyPublications') }}
				</h2>
			</div>

			<div v-if="currentPublications.length" class="row align-items-end justify-content-between">
				<div class="col-12 col-md-6 col-lg-3">
					<div class="drop-selector">
						<client-only>
							<b-dropdown variant="selector" :text="currentPublicationsOrder" class="w-100">
								<b-dropdown-item @click="changePublicationsOrder(order.desc)">
									{{ $t('newFirst') }}
								</b-dropdown-item>
								<b-dropdown-item @click="changePublicationsOrder(order.asc)">
									{{ $t('oldFirst') }}
								</b-dropdown-item>
							</b-dropdown>
						</client-only>
					</div>
				</div>
			</div>

			<ul v-if="currentPublications.length" class="questions_list">
				<li v-for="(publication, idx) in currentPublications" :key="idx" class="row">
					<div class="col-12 col-lg-3">
						<div class="question_author">
							<div class="title">
								{{ publication.date | moment('D MMMM YYYY') }}
							</div>
							<div class="description">
								{{ publication.author }}
							</div>
						</div>
					</div>

					<div v-if="publication.content_source" class="col-12 col-lg-3">
						{{ $t('contentSource') }}:
						<br>
						<strong>{{ publication.content_source.title }}</strong>
					</div>

					<div class="col-12 col-lg-4">
						<div class="d-sm-flex justify-content-between">
							<div class="question_item mr-sm-2">
								<div class="theme">
									{{ publication.category }}
								</div>
								<div class="title">
									{{ publication.title }}
								</div>

								<client-only>
									<b-collapse :id="`collapse-publication-${idx}`">
										{{ publication.intro }}
									</b-collapse>
								</client-only>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="d-sm-flex justify-content-end">
							<div v-if="!publication.is_has_blocks && publication.project_content_download_link" class="button">
								<a
									target="_blank"
									:href="publication.project_content_download_link"
									rel="nofollow noopener noreferrer"
									class="btn btn-outline-primary btn-icon icon-arrow_right mt-2"
								>
									{{ $t('contentSource') }}
								</a>
							</div>
							<div v-else class="button">
								<nuxt-link
									:to="$url.media(publication.slug, publication.taxonomy_type_slug, {}, publication.lang)"
									class="btn btn-outline-primary btn-icon icon-arrow_right mt-2"
								>
									{{ $t('article') }}
								</nuxt-link>
							</div>
						</div>
					</div>

					<div class="col-12">
						<div class="question_footer">
							<b-button
								v-if="publication.intro"
								v-b-tooltip.hover
								v-b-toggle="`collapse-publication-${idx}`"
								variant="resize"
								class="icon-chevron"
								title="Открыть"
							/>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="!loading && !currentPublications.length">
				<div v-if="$i18n.locale ==='ru'" class="container">Не нашлось публикаций.
				</div>
				<div v-if="$i18n.locale ==='en'" class="container">Unfortunately, no articles have been found yet.
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Publications',
	props: {
		categories: { type: Array, default: () => [] },
		personSlug: { type: String, default: '' },
		nameGenitive: { type: String, default: '' },
		isCacheCategory: { type: Boolean, default: true }, // категории кешируются, а не берутся каждый раз из апи
		isLoadFirstCategory: { type: Boolean, default: true }, // компонент изначально загружается с публикациями первой из списка категорий
		isLoadAllCategories: { type: Boolean, default: false }, // не реализовано. Если делать компонент универсальным, нужно переписать
	},
	data() {
		return {
			currentCategory: '',
			loading: true,
			currentPublications: [],
			order: {
				desc: 'Сначала новые',
				asc: 'Сначала старые',
			},
			currentPublicationsOrder: '',
		};
	},
	computed: {
		reversePublications() {
			return this.currentPublications.slice().reverse();
		},
	},
	created() {
		if (!this.isLoadAllCategories && this.isLoadFirstCategory) {
			this.changeCategory(this.categories[0]);

			// ВНИМАНИЕ! Не меняйте напрямую эти поля, не используйте в template и перепроверяйте на undefined через ?.
			this.cachedPublications = [];
			this.cachedCategories = [];
		}

		if (this.$i18n.locale === 'ru') {
			this.currentPublicationsOrder = 'Сначала новые';
		} else {
			this.currentPublicationsOrder = 'New ones first';
		}
	},
	methods: {
		changeCategory(category) {
			this.currentCategory = category;

			if (this.isCacheCategory && !this.cachedCategories?.includes(category)) {
				this.cacheCategory(category, this.personSlug)
					.then((publications) => this.currentPublications = publications);
			}

			if (this.isCacheCategory && this.cachedCategories?.includes(category)) {
				this.currentPublications = this.cachedPublications?.filter((p) => p.category === category);
			}
		},
		changePublicationsOrder(order) {
			if (this.currentPublicationsOrder === order) {
				return false;
			}

			this.currentPublicationsOrder = order;
			this.currentPublications = this.reversePublications;

			return true;
		},
		async cacheCategory(category, person) {
			const publications = await this.$api.publications(category, person);

			this.cachedCategories = this.cachedCategories?.concat(category);
			this.cachedPublications = this.cachedPublications?.concat(publications);

			this.loading = false;

			return publications;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/layouts/questions-page";
	.questions_list {
		border-top: 0;
		padding-top: 1rem;
	}
</style>
